export const getFAQ = (cruiseLine: App.CruiseLine, ship: App.CruiseShip, cruiseType: App.CruiseType): Array<App.CruiseFAQ> => {
  const buildVendorInfo = (): Array<string> => {
    const cruiseInfo = cruiseLine.vendorInfo?.filter((info) => info.dataType === 'General')[0]
    return cruiseInfo ? [cruiseInfo.text] : []
  }

  function buildShipInfo(): Array<string> {
    const shipFacilities = ship.shipInfo?.filter((info) => info.dataTypeName === 'General') ?? []
    return shipFacilities.map((info: App.CruiseShipInfo) => `<strong>${info.title}</strong><br />${info.description}`)
  }

  let content = [
    '<strong>Inside Cabin</strong> <br /> An inside cabin is normally the most affordable option, often without a window.',
    '<strong>Oceanview Cabin</strong> <br /> An oceanview cabin, often called an outside cabin, is a room with a port hole or window that looks out to sea, depending on deck and location.',
    '<strong>Balcony Cabin</strong> <br /> A balcony cabin is any cruise room with a private verandah, allowing you to take in the beautiful views and fresh sea air.',
    '<strong>Suite Cabin</strong> <br /> A suite is an especially large room within a cruise ship\'s top tier of cabins, often with a wide window and/or private verandah.',
  ]

  if (cruiseType === 'RIVER') {
    content = [
      '<strong>Window Cabin</strong> <br /> A window cabin is a room with a fixed picture window that looks onto the river and passing scenery, depending on deck and location.',
      '<strong>Balcony Cabin</strong> <br /> A balcony cabin is any cruise room with a private verandah, allowing you to take in the beautiful views and fresh air.',
      '<strong>Suite Cabin</strong> <br /> A suite is an especially large room within a cruise ship\'s top tier of cabins, often with a wide window and/or private verandah.',
    ]
  }

  return [
    {
      title: `Who is ${cruiseLine.name}?`,
      content: buildVendorInfo(),
      key: 'The vendor',
    },
    {
      title: 'What facilities are available on this cruise?',
      content: buildShipInfo(),
      key: 'The experience',
    },
    {
      title: 'What are the differences between the cabin types?',
      content,
      key: 'The differences',
    },
    {
      title: 'How many people can fit in a cabin?',
      content: ['The number of people that can fit in a cabin varies between cabin types. Twin Share cabins can accommodate two guests, unless it is specified that the cabins are solo, while Quad Share cabins can accommodate up to four or five guests, subject to individual cruise line policies.'],
      key: 'The group',
    },
    {
      title: 'What should I bring on a cruise?',
      content: [
        'Passport and ID',
        'Cash',
        'First aid kit',
        'Activity-specific clothing and shoes for facilities on the ship and onshore exploration',
        'Toiletries',
        'Carry-on bag and/or backpack for onshore exploration',
      ],
      key: 'The belongings',
    },
    {
      title: 'Do I need to be fully vaccinated?',
      content: ['Vaccination requirements vary between individual cruise lines. It is strongly recommended to double check the specific cruise line\'s vaccination policy and requirements prior to boarding.'],
      key: 'The Vaccine',
    },
    {
      title: 'What are the Terms & Conditions?',
      content: ['The terms and conditions can be found <a href="https://luxuryescapes.com/au/booking-policies#cruises" target="_blank" rel="noopener noreferrer">here.</a>'],
      key: 'The terms',
    },
  ]
}
